import { render, staticRenderFns } from "./goodsReturn.vue?vue&type=template&id=2887c6b3&"
import script from "./goodsReturn.vue?vue&type=script&lang=js&"
export * from "./goodsReturn.vue?vue&type=script&lang=js&"
import style0 from "./goodsReturn.vue?vue&type=style&index=0&id=2887c6b3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports